import { DocumentContent } from '../types';

const invalidLicenseId = '-1';

type DocumentContentWithLicense = Extract<DocumentContent, { license?: string; }>;

function hasLicense(content: DocumentContent): content is DocumentContentWithLicense {
  return 'license' in content && content.license != null;
}

export function isUnlicensedOrLicenseValid(content: DocumentContent): content is DocumentContentWithLicense {
  if (!hasLicense(content)) {
    return true;
  }

  return content.license !== invalidLicenseId;
}
